import type { WorkflowWebhook } from './types';

export const CONTENT_TYPES = {
  json: { value: 'Json', display: 'JSON' },
  formUrlEncoded: { value: 'FormUrlEncoded', display: 'Form URL Encoded' },
};

export const CONTENT_TYPE_LABELS = {
  Json: 'JSON',
  FormUrlEncoded: 'URL-encoded form',
};

export const FORM_URL_ENCODED_CONTENT_TYPE = 'FormUrlEncoded';
export const JSON_CONTENT_TYPE = 'Json';
export const AUTH_HEADER = 'Authorization';
export const OAUTH_AUTH_TYPE = 'OAuth2';
export const BASIC_AUTH_PREFIX = 'Basic ';

export const NEW_WEBHOOK: WorkflowWebhook = {
  name: '',
  endpoint: '',
  destination: 'Custom',
  method: 'POST',
  contentType: 'Json',
  clientId: '',
  tokenEndpoint: '',
  clientSecret: '',
  authType: 'NoAuth',
  headers: [],
  userFields: [],
  basicAuthToken: '',
  body: [],
  formBody: [],
  jsBody: '',
  includeDefaultFields: true,
};

export const INKIT_DATA: WorkflowWebhook = {
  name: '',
  destination: 'Inkit',
  method: 'POST',
  clientId: '',
  clientSecret: '',
  tokenEndpoint: '',
  basicAuthToken: '',
  body: [],
  jsBody: '',
  includeDefaultFields: true,
  userFields: [],
  endpoint: 'https://internal.inkit.io/integrations/iterable/webhook',
  headers: [
    {
      key: 'Authorization',
      value: '',
    },
  ],
  authType: 'NoAuth',
  contentType: FORM_URL_ENCODED_CONTENT_TYPE,
  formBody: [
    {
      key: 'template_id',
      value: '',
    },
    {
      key: 'first_name',
      value: '',
    },
    {
      key: 'last_name',
      value: '',
    },
    {
      key: 'company',
      value: '',
    },
    {
      key: 'phone',
      value: '',
    },
    {
      key: 'address_line_1',
      value: '',
    },
    {
      key: 'address_line_2',
      value: '',
    },
    {
      key: 'address_city',
      value: '',
    },
    {
      key: 'address_state',
      value: '',
    },
    {
      key: 'address_zip',
      value: '',
    },
    {
      key: 'address_country',
      value: '',
    },
    {
      key: 'source',
      value: '',
    },
  ],
};

export const AUTH_TYPES = {
  Basic: 'Basic',
  NoAuth: 'None',
  OAuth2: 'OAuth 2.0',
};

export const dropdowns = {
  destination: [
    {
      id: 'custom',
      label: 'Custom',
      value: 'Custom',
    },
    {
      id: 'inkit',
      label: 'Inkit',
      value: 'Inkit',
    },
  ],
  method: [
    {
      id: 'delete',
      label: 'DELETE',
      value: 'DELETE',
    },
    {
      id: 'get',
      label: 'GET',
      value: 'GET',
    },
    {
      id: 'patch',
      label: 'PATCH',
      value: 'PATCH',
    },
    {
      id: 'post',
      label: 'POST',
      value: 'POST',
    },
    {
      id: 'put',
      label: 'PUT',
      value: 'PUT',
    },
  ],
  authType: [
    {
      id: 'basic',
      label: 'Basic',
      value: 'Basic',
    },
    {
      id: 'none',
      label: 'None',
      value: 'NoAuth',
    },
    {
      id: 'oauth',
      label: 'OAuth 2.0',
      value: 'OAuth2',
    },
  ],
  contentType: [
    {
      id: 'json',
      label: 'JSON',
      value: 'Json',
    },
    {
      id: 'urlEncodedForm',
      label: 'URL-encoded form',
      value: 'FormUrlEncoded',
    },
  ],
};

export const t = {
  saveButton: 'Update webhook',
  cancelButton: 'Cancel',
  createButton: 'Create webhook',
  name: {
    id: 'name',
    label: 'Name',
    errorText: 'Enter a name',
  },
  destination: {
    id: 'destination',
    label: 'Destination',
  },
  method: {
    id: 'method',
    label: 'Method',
  },
  endpoint: {
    id: 'endpoint',
    label: 'Endpoint',
    helpText: 'Use {{#urlEncode}}{{myParam}}{{/urlEncode}} to encode parameters',
    errorText: 'Endpoint URL must contain http:// or https:// and a valid domain',
  },
  authType: {
    id: 'authType',
    label: 'Authentication',
  },
  basicAuthToken: {
    id: 'basicAuthToken',
    label: 'Authentication token',
    helpText:
      'Copy your token and store it in a secure location. It may be required for subsequent updates. After webhook creation, you will not be able to view it again.',
  },
  clientId: {
    id: 'clientId',
    label: 'Client ID',
  },
  clientSecret: {
    id: 'clientSecret',
    label: 'Client secret',
    helpText:
      'Copy your secret and store it in a secure location. After webhook creation, you will not be able to view it again.',
  },
  tokenEndpoint: {
    id: 'tokenEndpoint',
    label: 'Token URL',
  },
  headers: {
    id: 'headers',
    label: 'Custom headers',
    subLabel: '(Optional)',
    hint: 'Some endpoints require specific HTTP headers with each incoming request.',
    errorText: 'Key required',
    basicAuthErrorText: 'Authorization token required for custom header update',
  },
  contentType: {
    id: 'contentType',
    label: 'Body',
  },
  formBody: {
    id: 'formBody',
    name: 'Name',
    value: 'Value',
    errorText: 'Must have name',
  },
  jsBody: {
    id: 'jsBody',
  },
  userFields: {
    id: 'userFields',
  },
} as const;

export const SECURE_CREDENTIAL_VALUE = '********';
